import { cnva } from '@/app/utils/cnva';

export const TopNavigationStyled = cnva('top-0 left-0 z-30 h-14 w-full', {
  variants: {
    variant: {
      filled: 'sticky',
      transparent: 'transition-bg fixed',
    },
    showBackground: {
      true: 'bg-white shadow-md',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'filled',
    showBackground: true,
  },
});
